import AppBarCommon from "../../app-bar-common";

const AcceptInvitationHeader = () => {
  return (
    <>
      <AppBarCommon
        title="Accept Invitation"
        isUserIcon
        isSearch={false}
        isIconDefine={false}
      />
    </>
  );
};

export default AcceptInvitationHeader;
